/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Dependency: CountUp.js: https://github.com/inorganik/CountUp.js

// (function ($) {
//   $.fn.countup = function (params) {
//     // make sure dependency is present
//     if (typeof CountUp !== 'function') {
//       console.error('countUp.js is a required dependency of countUp-jquery.js.');
//       return;
//     }

//     var defaults = {
//       startVal: 0,
//       decimalPlaces: 0,
//       duration: 2,
//     };

//     if (typeof params === 'number') {
//       defaults.endVal = params;
//     }
//     else if (typeof params === 'object') {
//       $.extend(defaults, params);
//     }
//     else {
//       console.error('countUp-jquery requires its argument to be either an object or number');
//       return;
//     }

//     this.each(function (i, elem) {
//       var countUp = new CountUp(elem, defaults.endVal, defaults);
//       countUp.start();
//     });

//     return this;
//   };

// }(jQuery));

jQuery(document).ready(function($){
  $('body').on('click','.quick_ajax_add',function(e){
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    $('.PageOverlay').addClass('is-visible');
    var id = $(this).data('var_id');
    var is_cart = false;
    var i = 1;   

    if(window.location.pathname.indexOf('cart') > -1){
      is_cart = true;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      async: false,
      data: { id: id, quantity: i },
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);            
      },
      success: function() {
        if(is_cart){
          location.reload();
        }
        else{
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              variant: id,
              quantity: 1
            }
          }));
        }
      }         
    });
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  });
  
  // $(".PressSlider_Logos").slick({
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 4,
  //   // asNavFor: '.PressSlider_Quote',
  //   arrows: false,
  //   dots: false,
  //   focusOnSelect: true,
  //   // prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><circle r="18" transform="matrix(-1 0 0 1 18 18)" fill="white"/><path d="M20 14L15.5 18.5L20 23" stroke="#505B71" stroke-width="2" stroke-linecap="round"/></svg></button>',
  //   // nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none"><circle cx="18" cy="18" r="18" fill="white"/><path d="M16 14L20.5 18.5L16 23" stroke="#505B71" stroke-width="2" stroke-linecap="round"/></svg></button>',
  //   responsive: [{
  //       breakpoint: 640,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 2,
  //         dots: true
  //         // arrows: true
  //       }
  //   }]
  // });

  $('.BA_Images').each(function(){
    $(this).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true
    })
  })


  // setTimeout(function(){
  //   var search_params = window.location.search;
  //   if(search_params.indexOf('selling_plan=') > -1){
  //     $('<p style="font-weight: bold;color: #ff756b;">Auto replenish items are NOT eligible for local pick up</p>').insertBefore('.rc-selling-plans-dropdown__select');
  //   }
  // }, 2000)

  // $(document).on('change', '.rc-radio__input', function(e){
  //   var rc_radio_value = $('.rc-radio__input:checked').val();
  //   if(rc_radio_value == 'subscription'){
  //     $('<p style="font-weight: bold">Auto replenish items are NOT eligible for local pick up</p>').insertBefore('.rc-selling-plans-dropdown__select');
  //   }
  //   console.log($('.rc-radio__input:checked').val());
  // })
})
 
//  $(document).ready(() => {
//                   window.prefetchUrlArr = []
//   function r(e) {
//     if (
//       ((window.prefetchUrlArr = window.prefetchUrlArr || []),
//       !window.prefetchUrlArr.includes(e) && e && e.includes("/"))
//     ) {
//       window.prefetchUrlArr.push(e);
//       let t = `<link rel="prefetch" href="${e}">`;
//       $("head").eq(0).append(t);
//     }
//   }
//   $("a").one( "mouseenter touchstart", function () {
//     let e = $(this).attr("href") || $(this).data("url");
//     r(e);
//   });

// });

$(".product__dropdown-header").click((function() {
  $(this).parent().toggleClass("active");
  $(this).siblings(".product__dropdown-content").slideToggle(300);
}));